/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {useIsMobile} from "../../../table/Table";
import {OrderRowSkeleton} from "./OrderRowSkeleton";
import {OrderRowHeaderSkeleton} from "./OrderRowHeaderSkeleton";
import {OrderRowSkeletonMobile} from "./OrderRowSkeletonMobile";

export const OrderSkeleton = () => {
    const isMobile = useIsMobile();

    return isMobile ?
        <>{[...Array(5)].map((item, i) => <OrderRowSkeletonMobile key={i}/>)}</>
        :
        <><OrderRowHeaderSkeleton/>{[...Array(5)].map((item, i) => <OrderRowSkeleton key={i}/>)}</>
}

